import styled from "styled-components";
import { motion } from "framer-motion";

export const Section = styled.div`
  background-color: rgb(0, 0, 0);
  padding: 6.9444vw;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const VideoWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  max-height: 55.5556vw;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 100vw;
  }
`;

export const VideoWrapper = styled(motion.article)`
  flex: 0 0 auto;
  height: calc(100% + 120px);
  position: relative;
  width: 100%;
`;

export const Video = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
`;
